import { atom, selector } from "recoil"
import { accountSelector } from "src/recoil/selectors/account/accountSelector"

export const jobIdState = atom({
  key: "atoms/account/jobIdState",
  default: selector({
    key: "atoms/account/jobIdState_default",
    get: ({ get }) => {
      const account = get(accountSelector)
      return account?.jobId
    },
  }),
})
